import apiVersion from '../api/VersionAPI';

const getCurrentVersion = async () => {
    const result = await apiVersion.getCurrentVersion();
    return result;
};

export default {
    getCurrentVersion: getCurrentVersion,
}